import $ from 'jquery';

function sectionNavigation(el) {
    const links = $(el).find('a');

    const observer = new IntersectionObserver(entries => {
        entries.map((entry) => {
            if (entry.isIntersecting) {
                const id = entry.target.id;
                links.each((index) => {
                    const hash = links[index].hash;

                    if (`#${id}` === hash) {
                        $(links[index]).addClass('active');
                    } else {
                        $(links[index]).removeClass('active');
                    }
                });
            }
        });
    }, { threshold: 0.09 });

    let elements = [];
    links.get().map((e) => {
        const hash = e.hash;
        elements.push($(hash).get()[0]);
    });

    elements.forEach(element => observer.observe(element));

    links.on('click', (e) => {
        e.preventDefault();
        const hash = e.target.hash;
        const destination = $(hash);

        $('html, body').animate({
            scrollTop: destination.offset().top
        }, 'slow');
    });
}

export default sectionNavigation;
